import { useLanguage } from '@/i18n/LanguageProvider';
import { connectedTaskStateKey, type ConnectedTaskItem, type ConnectedTaskProvider } from '../../../supabase/functions/_shared/connectedTaskDomain';
export function ConnectedTaskStatus({ provider, item }: { provider: ConnectedTaskProvider; item: ConnectedTaskItem }) {
  const { t } = useLanguage();
  const key = connectedTaskStateKey(provider, item);
  return key ? <span className="block text-xs text-muted-foreground">{t('mirror.connectedTasks.read.' + key)}</span> : null;
}
